// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3FdBb","footer":"ModalInfo_footer__3uH0h"};